<template>
    <form method="POST"
          @submit="checkForm"
          action="/forms/search">

        <input type="hidden" name="_token" v-bind:value="csrf">
        <input type="hidden" name="form-name" value="contact"/>

        <label for="place">Kies één plaats, buurt of wijk</label>
        <input
            type="text"
            id="place"
            name="place"
            placeholder="Plaats, buurt of wijk"
            v-model="place"
            @keyup="checkPlace"
            v-bind:class="{ error: hasPlaceError, valid: placeIsValid }">

        <label for="priceMin">Prijsklasse</label>
        <select
            id="priceMin"
            name="min_price"
            class="half"
            v-model="priceMin"
            @change="checkPriceMin"
            :class="{changed: priceMinIsChanged }">
            <option value selected>&euro; 0</option>
            <option value="50.000">&euro; 50.000</option>
            <option value="75.000">&euro; 75.000</option>
            <option value="100.000">&euro; 100.000</option>
            <option value="125.000">&euro; 125.000</option>
            <option value="150.000">&euro; 150.000</option>
            <option value="175.000">&euro; 175.000</option>
            <option value="200.000">&euro; 200.000</option>
            <option value="225.000">&euro; 225.000</option>
            <option value="250.000">&euro; 250.000</option>
            <option value="275.000">&euro; 275.000</option>
            <option value="300.000">&euro; 300.000</option>
            <option value="325.000">&euro; 325.000</option>
            <option value="350.000">&euro; 350.000</option>
            <option value="375.000">&euro; 375.000</option>
            <option value="400.000">&euro; 400.000</option>
            <option value="450.000">&euro; 450.000</option>
            <option value="500.000">&euro; 500.000</option>
            <option value="550.000">&euro; 550.000</option>
            <option value="600.000">&euro; 600.000</option>
            <option value="650.000">&euro; 650.000</option>
            <option value="700.000">&euro; 700.000</option>
            <option value="750.000">&euro; 750.000</option>
            <option value="800.000">&euro; 800.000</option>
            <option value="900.000">&euro; 900.000</option>
            <option value="1.000.000">&euro; 1.000.000</option>
            <option value="1.250.000">&euro; 1.250.000</option>
            <option value="1.500.000">&euro; 1.500.000</option>
            <option value="2.000.000">&euro; 2.000.000</option>
        </select>
        <select
            id="priceMax"
            name="max_price"
            class="half"
            v-model="priceMax"
            @change="checkPriceMax"
            :class="{changed: priceMaxIsChanged }">
            <option value="50.000">&euro; 50.000</option>
            <option value="75.000">&euro; 75.000</option>
            <option value="100.000">&euro; 100.000</option>
            <option value="125.000">&euro; 125.000</option>
            <option value="150.000">&euro; 150.000</option>
            <option value="175.000">&euro; 175.000</option>
            <option value="200.000">&euro; 200.000</option>
            <option value="225.000">&euro; 225.000</option>
            <option value="250.000">&euro; 250.000</option>
            <option value="275.000">&euro; 275.000</option>
            <option value="300.000">&euro; 300.000</option>
            <option value="325.000">&euro; 325.000</option>
            <option value="350.000">&euro; 350.000</option>
            <option value="375.000">&euro; 375.000</option>
            <option value="400.000">&euro; 400.000</option>
            <option value="450.000">&euro; 450.000</option>
            <option value="500.000">&euro; 500.000</option>
            <option value="550.000">&euro; 550.000</option>
            <option value="600.000">&euro; 600.000</option>
            <option value="650.000">&euro; 650.000</option>
            <option value="700.000">&euro; 700.000</option>
            <option value="750.000">&euro; 750.000</option>
            <option value="800.000">&euro; 800.000</option>
            <option value="900.000">&euro; 900.000</option>
            <option value="1.000.000">&euro; 1.000.000</option>
            <option value="1.250.000">&euro; 1.250.000</option>
            <option value="1.500.000">&euro; 1.500.000</option>
            <option value="2.000.000">&euro; 2.000.000</option>
            <option value selected>Geen maximum</option>
        </select>

        <label for="place">Soort object</label>
        <select
            name="house_type"
            id="object"
            v-model="object"
            @change="checkObject"
            :class="{changed: objectIsChanged }">
            <option value selected>Geen voorkeur</option>
            <option value="0">Villa</option>
            <option value="1">Twee-onder-een-kap</option>
            <option value="2">Eengezinswoning</option>
            <option value="3">Hoekwoning</option>
            <option value="4">Appartement</option>
        </select>

        <label for="place">Aantal kamers</label>
        <select
            name="rooms"
            id="rooms"
            v-model="rooms"
            @change="checkRooms"
            :class="{changed: roomsIsChanged }">
            <option value selected>Geen voorkeur</option>
            <option value="1">1+ kamers</option>
            <option value="2">2+ kamers</option>
            <option value="3">3+ kamers</option>
            <option value="4">4+ kamers</option>
            <option value="5">5+ kamers</option>
        </select>

        <label for="livingSurface">Woonoppervlakte</label>
        <select
            name="living_area"
            id="livingSurface"
            v-model="livingSurface"
            @change="checkLivingSurface"
            :class="{changed: livingSurfaceIsChanged }">
            <option value selected>Geen voorkeur</option>
            <option value="50">50+ m2</option>
            <option value="75">75+ m2</option>
            <option value="100">100+ m2</option>
            <option value="150">150+ m2</option>
            <option value="200">200+ m2</option>
            <option value="250">250+ m2</option>
        </select>

        <label for="parcelSurface">Perceeloppervlakte</label>
        <select
            name="plot_area"
            id="parcelSurface"
            @change="checkParcelSurface"
            v-model="parcelSurface"
            :class="{changed: parcelSurfaceIsChanged }">
            <option value selected>Geen voorkeur</option>
            <option value="50">50+ m2</option>
            <option value="75">75+ m2</option>
            <option value="100">100+ m2</option>
            <option value="150">150+ m2</option>
            <option value="200">200+ m2</option>
            <option value="250">250+ m2</option>
            <option value="500">500+ m2</option>
            <option value="1000">1000+ m2</option>
            <option value="2000">2000+ m2</option>
        </select>

        <label for="name">Naam</label>
        <input
            name="name"
            id="name"
            type="text"
            placeholder="Jouw naam"
            v-model="name"
            @keyup="checkName"
            v-bind:class="{ error: hasNameError, valid: nameIsValid }">

        <label for="telephone">Telefoon</label>
        <input
            name="phone"
            type="text"
            id="telephone"
            placeholder="Mobiel of vast nummer"
            v-model="tel"
            @keyup="checkTel"
            v-bind:class="{ error: hasTelError, valid: telIsValid }">

        <label for="email">E-mail</label>
        <input
            name="email"
            type="email"
            id="email"
            placeholder="naam@voorbeeld.nl"
            v-model="email"
            @keyup="checkEmail"
            v-bind:class="{ error: hasEmailError, valid: emailIsValid }">

        <label for="comment">Opmerkingen</label>
        <textarea
            name="comment"
            type="text"
            id="comment"
            placeholder="Typ hier uw opmerking"
            v-model="question"></textarea>

        <div class="checkbox">
            <input
                name="newsletter"
                type="checkbox"
                id="nieuwsbrief"
                v-model="newsletter">
            <label for="nieuwsbrief">
                Hou mij op de hoogte van de huizenmarkt en speciale aanbiedingen
            </label>
        </div>

        <div class="checkbox">
            <input
                name="privacy"
                type="checkbox"
                id="privacy"
                v-model="privacy"
                v-bind:class="{ error: hasPrivacyError, valid: privacyIsValid }"
                >
            <label for="privacy">
                Ik ga akkoord met de&nbsp;<a href="/privacyverklaring">privacyverklaring</a>
            </label>
        </div>

        <button type="submit" class="button">Verstuur en betaal €49,50</button>
    </form>

</template>

<script>
    export default {
        data() {
            return {
                tel: '',
                hasTelError: false,
                telIsValid: false,

                place: '',
                hasPlaceError: false,
                placeIsValid: false,

                email: '',
                hasEmailError: false,
                emailIsValid: false,

                name: '',
                hasNameError: false,
                nameIsValid: false,

                privacy: '',
                hasPrivacyError: false,
                privacyIsValid: false,

                question: '',

                newsletter: '',

                parcelSurface: '',
                parcelSurfaceIsChanged: false,

                priceMin: '',
                priceMinIsChanged: false,

                priceMax: '',
                priceMaxIsChanged: false,

                object: '',
                objectIsChanged: false,

                rooms: '',
                roomsIsChanged: false,

                livingSurface: '',
                livingSurfaceIsChanged: false
            }
        },

        mounted() {
            if (this.error !== 'false') {
                const kaas = document.querySelector('input[name=' + this.error + ']');
                kaas.classList.add("error");
            }
        },

        props: ['csrf', 'oldName', 'error'],

        methods: {

            checkName() {
                this.hasNameError = !this.name;
                this.nameIsValid = this.name;
            },

            checkTel() {
                this.hasTelError = !this.validTel(this.tel);
                this.telIsValid = this.tel;
            },

            checkPlace() {
                this.hasPlaceError = !this.place;
                this.placeIsValid = this.place;
            },

            checkEmail() {
                this.hasEmailError = !this.validEmail(this.email);
                this.emailIsValid = this.email;
            },

            checkPrivacy() {
                this.hasPrivacyError = !this.privacy;
                this.privacyIsValid = this.privacy;
            },

            checkParcelSurface() {
                this.parcelSurfaceIsChanged = true;
            },

            checkPriceMin() {
                this.priceMinIsChanged = true;
            },

            checkPriceMax() {
                this.priceMaxIsChanged = true;
            },

            checkObject() {
                this.objectIsChanged = true;
            },

            checkRooms() {
                this.roomsIsChanged = true;
            },

            checkLivingSurface() {
                this.livingSurfaceIsChanged = true;
            },

            checkForm(e) {

                this.checkName();
                this.checkTel();
                this.checkEmail();
                this.checkPrivacy();
                this.checkPlace();

                if (this.privacyIsValid &&
                    this.emailIsValid &&
                    this.telIsValid &&
                    this.nameIsValid) {
                    return true;
                }

                e.preventDefault();
            },

            validEmail(email) {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            validTel(telephone) {
                let re = /^\d{10}$/;
                return re.test(telephone);
            }
        }

    }
</script>
